import Resource from './resource.js';

export default class Documents extends Resource {
    async genCertificate() {
		this.httpDownload("documents/generate", "certificate.pdf", true);
    }
}
